module.exports = __webpack_public_path__ + "img/PD1504990701321060352.79d66ea0.png";